import apiClient from './apiClient';

export interface ProductCacheEntry {
  productId: string;
  retailer: string;
  cachedAt: string;
  updatedAt: string;
  expiresAt?: string;
  isExpired: boolean;
  daysSinceCached: number;
}

export interface ProductCacheDetail {
  productId: string;
  retailer: string;
  productDataJson: string;
  cachedAt: string;
  updatedAt: string;
  expiresAt?: string;
  isExpired: boolean;
  daysSinceCached: number;
}

export interface ProductCacheStats {
  totalProducts: number;
  expiredProducts: number;
  productsByRetailer: Record<string, number>;
  oldestCachedAt?: string;
  newestCachedAt?: string;
}

export interface PaginatedProductCacheResponse {
  items: ProductCacheEntry[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

const productCacheAdminService = {
  getAll: async (pageNumber = 1, pageSize = 50, retailer?: string, searchTerm?: string) => {
    const params = new URLSearchParams({
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });
    if (retailer) params.append('retailer', retailer);
    if (searchTerm) params.append('search', searchTerm);
    
    const response = await apiClient.get(`/admin/product-cache?${params}`);
    return response.data;
  },

  getById: async (productId: string, retailer: string) => {
    const response = await apiClient.get(`/admin/product-cache/${productId}/${retailer}`);
    return response.data;
  },

  delete: async (productId: string, retailer: string) => {
    const response = await apiClient.delete(`/admin/product-cache/${productId}/${retailer}`);
    return response.data;
  },

  getStats: async () => {
    const response = await apiClient.get('/admin/product-cache/stats');
    return response.data;
  },
};

export default productCacheAdminService;

